import { Box } from '@mui/material';
import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledBabaSpecialOffer = styled.div`
  max-width: 343px;
  height: 277.3px;
  font-family: var(--font-family), Ariel;
  position: relative;
  background: ${(props: any) =>
    props.backgroundSrc
      ? `url("${props.backgroundSrc}")`
      : createGradientOrSolid(props.backgroundColor)};
  background-size: cover;
  margin: 0 auto;

  .container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 6px 15.3px;
  }

  .scroller {
    height: calc(100% - 115px);
    right: -1px;
    bottom: 0;
    box-shadow: inset -26px 0px 16px -10px #48075a;
    width: 50px;
    position: absolute;
    z-index: 10000;

    > button {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      border: 0;
      position: relative;
      background: #78c1e7;
      box-shadow: 0 2px 3px 0 #0b4969;
      left: 35px;
      top: calc(50% - 12px);
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .products {
    display: flex;
    flex-direction: column;
    background-size: 100% 100%;
    position: relative;
    align-items: center;

    & > div:not(.scroller) {
      &.sub {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        position: relative;
        padding: 4px;
      }
    }
  }
` as any;

export const StyledPriceSection = styled(Box)`
  display: flex;
  width: 100%;
  position: relative;

  .availability-label {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 4px;
    color: #fff;
    text-shadow: 0px 1px 1px #000;
    font-size: 12px;
    font-weight: 400;
  }
` as any;
